import { api } from "../../../../services/api";
import type {
  DownloadCourseResult,
  DownloadCoursesResponse,
  DownloadFilters,
  DownloadOptions,
  DownloadParts,
  DownloadsLock,
} from "./downloads.types";

const BASE = "/content-hub/downloads";

// Like the upload hub's, these let the error through: the runner turns the
// server's message into the text each row shows.

export const getDownloadOptions = async (): Promise<DownloadOptions> => {
  const response = await api.get(`${BASE}/options`);
  return response.data;
};

// An empty filter is left out: the backend reads it as "all".
export const getDownloadCourses = async (
  filters: DownloadFilters,
): Promise<DownloadCoursesResponse> => {
  const params: Record<string, string> = {};
  if (filters.grades.length > 0) params.grades = filters.grades.join(",");
  if (filters.subjects.length > 0) params.subjects = filters.subjects.join(",");
  if (filters.trimesters.length > 0) {
    params.trimesters = filters.trimesters.join(",");
  }
  const response = await api.get(`${BASE}/courses`, { params });
  return response.data;
};

// Repeating it only overwrites the same files, so it is safe to retry.
export const downloadCourse = async (
  courseId: number,
  parts: DownloadParts,
): Promise<DownloadCourseResult> => {
  const response = await api.post(`${BASE}/courses/${courseId}`, {
    od: parts.od,
    quiz: parts.quiz,
    quizVideo: parts.quizVideo,
    // Left out when not asked, so an OD and quiz run sends what it always did.
    ...(parts.odSummary ? { odSummary: true } : {}),
  });
  return response.data;
};

// A 409 says someone else holds some of these courses, or, when renewing,
// that this lock was lost.
export const acquireDownloadsLock = async (
  courseIds: number[],
): Promise<DownloadsLock> => {
  const response = await api.post(`${BASE}/locks`, { courseIds });
  return response.data;
};

export const renewDownloadsLock = async (lockId: string): Promise<void> => {
  await api.patch(`${BASE}/locks/${encodeURIComponent(lockId)}`);
};

export const releaseDownloadsLock = async (lockId: string): Promise<void> => {
  await api.delete(`${BASE}/locks/${encodeURIComponent(lockId)}`);
};
